import { FC, useMemo } from 'react';
import {
  AskonaBannerFlowerBig,
  AskonaBannerFlowerSmall,
} from '@app/ui/iconComponents';
import BannerBase, { CommonBannerProps } from '../BannerBase';
import { COLORS } from '@app/constants';
import styled from 'styled-components';
import { useClientSize } from '@app/hooks';

const AskonaBanner: FC<CommonBannerProps> = ({
  title = 'Вместе с askona мы подготовили команду, которая специализируется на работе со сном. Улучшая сон, ты  значительно повышаешь качество твоей жизни.',
  className,
  margin,
}) => {
  const { getIsBreakpoint } = useClientSize();
  const isMobile = getIsBreakpoint('sm');

  const decorators = useMemo(() => {
    if (isMobile) return <StyledBannerSmall />;

    return <StyledBannerBig />;
  }, [isMobile]);

  return (
    <BannerBase
      margin={margin}
      content={title}
      maxTitleWidth="435px"
      className={className}
      color={COLORS.askonaLight}
      backgroundText="Сон"
    >
      {decorators}
    </BannerBase>
  );
};

const StyledBannerBig = styled(AskonaBannerFlowerBig)`
  transform: translate(95px, 270px);
`;

const StyledBannerSmall = styled(AskonaBannerFlowerSmall)`
  transform: translate(0, 48px);
`;

export default AskonaBanner;
